import { HTMLAttributes } from 'react';
import { useJoveBreakpoint } from '@jove-frontend/uikit';
import { Box, Typography } from '@mui/material';
import clsx from 'clsx';

export interface InsurerLogo {
  name: string;
  url: string;
  height?: string | number;
}

// Default insurers data - can be easily added/removed
const DEFAULT_INSURERS: InsurerLogo[] = [
  {
    name: 'Hiscox',
    url: 'https://storage.googleapis.com/jove-public-images/website/landing-pages/insurers/hiscox-logo.png',
    height: '24px',
  },
  {
    name: 'Great American',
    url: 'https://storage.googleapis.com/jove-public-images/website/landing-pages/insurers/great-american-logo.png',
    height: '48px',
  },
  {
    name: 'Chubb',
    url: 'https://storage.googleapis.com/jove-public-images/website/landing-pages/insurers/chubb-logo.png',
    height: '24px',
  },
  {
    name: 'Accelerant',
    url: 'https://storage.googleapis.com/jove-public-images/website/landing-pages/insurers/accelerant-logo.png',
    height: '48px',
  },
];

interface BackedByPanelProps extends HTMLAttributes<HTMLDivElement> {
  insurers?: InsurerLogo[];
  logoHeight?: string | number;
  post?: any;
}

const BackedByPanel = (props: BackedByPanelProps) => {
  const { insurers = DEFAULT_INSURERS, logoHeight = '24px', className, post } = props;
  const { isMobileLayout } = useJoveBreakpoint();

  const normalizeHeight = (height: string | number | undefined): string | number => {
    if (height !== undefined) return height;
    return logoHeight;
  };

  return (
    <Box className={clsx('flex flex-col items-center space-y-6 py-8', className)}>
      <Typography variant="subtitle1" className="text-primary-black text-lg font-bold">
        {post?.backedByTitle}
      </Typography>
      <Box className={clsx('flex items-center justify-center gap-8', isMobileLayout ? 'flex-wrap px-4' : 'flex-row')}>
        {insurers.map((insurer) => (
          <Box
            key={insurer.name}
            component="img"
            src={insurer.url}
            alt={insurer.name}
            sx={{
              height: normalizeHeight(insurer.height),
              width: 'auto',
              objectFit: 'contain',
            }}
          />
        ))}
      </Box>
    </Box>
  );
};

export default BackedByPanel;
